import NewWhatsAppEvent from './NewWhatsAppEvent';

export default class WhatsAppTransferEvent extends NewWhatsAppEvent {
  constructor(body) {
    body.activeAttendance = !!body.whatsAppCampaign;

    body.transfer = true;
    super(body);
  }
}
